// ---------------------------------------------
// ======---------------------------------======
// Main MBP JS
// ======---------------------------------======
// ---------------------------------------------

// ------------------------------------------------
// Helper Functions
// ------------------------------------------------

// Make foreach functions play nice with query selector all
const forEachAll = function(array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

// A simeple check to see if element exists
const doIexist = function(element, callback) {
  if (document.querySelector(element)) {
    callback();
  }
};

// checks if element has a class
function hasClass(element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

// ------------------------------------------------
// Main Nav
// ------------------------------------------------
if (document.querySelector('[data-toggle="nav"]')) {
  const menutoggles = document.querySelectorAll('[data-toggle="nav"]');

  // Add overlay for nav
  let menuoverlay = document.createElement('div');
  menuoverlay.classList.add('sh-overlay');
  document.querySelector('.site-header').appendChild(menuoverlay);

  forEachAll(menutoggles, function(index) {
    menutoggles[index].addEventListener('click', function(e) {
      e.preventDefault();
      let menuid = this.getAttribute('data-parent');

      document.querySelector(`[data-nav="${menuid}"]`).classList.toggle('active');
      document.querySelector('body').classList.toggle('nav-open');
    });
  });

  // Close menu when clicking over lay
  document.querySelector('.sh-overlay').addEventListener('click', function(e) {
    e.preventDefault();

    document.querySelector('[data-nav="main-nav"]').classList.remove('active');
    document.querySelector('body').classList.remove('nav-open');
  });

  // close menu when clicking nav-featured li
  const nmlistitem = document.querySelectorAll('.nm__list a');
  forEachAll(nmlistitem, function(index) {
    nmlistitem[index].addEventListener('click', function() {
      document.querySelector('[data-nav="main-nav"]').classList.remove('active');
      document.querySelector('body').classList.remove('nav-open');
    });
  });

  // close menu when clicking nav-featured li
  document.querySelector('.nav-featured li a').addEventListener('click', function(e) {
    document.querySelector('[data-nav="main-nav"]').classList.remove('active');
    document.querySelector('body').classList.remove('nav-open');
  });
}

// ------------------------------------------------
// Accordion Simple
// ------------------------------------------------
const astoggles = document.querySelectorAll('[data-toggle="accordion-simple"]');

const asclear = function(callback) {
  forEachAll(astoggles, function(index) {
    let menuid = astoggles[index].getAttribute('data-parent');
    document.querySelector(`#${menuid}`).classList.remove('js-open');

    setTimeout(() => {
      callback();
    }, 10);
  });
};

forEachAll(astoggles, function(index) {
  astoggles[index].addEventListener('click', function() {
    let menuid = this.getAttribute('data-parent'),
      menuparent = document.querySelector(`#${menuid}`);

    if (hasClass(menuparent, 'js-open')) {
      menuparent.classList.remove('js-open');
    } else {
      asclear(function() {
        menuparent.classList.add('js-open');
      });
    }
  });
});

// ------------------------------------------------
// Change location
// ------------------------------------------------
if (document.querySelector('[data-location-toggle]')) {
  const locationtoggles = document.querySelectorAll('[data-location-toggle]');
  const locationhides = document.querySelectorAll('[data-location-hide]');

  forEachAll(locationtoggles, function(index) {
    locationtoggles[index].addEventListener('click', function(event) {
      event.stopPropagation();

      let toggleid = this.getAttribute('data-location-toggle');

      document.getElementById(toggleid).classList.add('active');

      document.getElementById(toggleid).addEventListener('click', function(event) {
        event.stopPropagation();
      });
    });
  });

  forEachAll(locationhides, function(index) {
    locationhides[index].addEventListener('click', function(event) {
      event.stopPropagation();

      let toggleid = this.getAttribute('data-location-hide');

      document.getElementById(toggleid).classList.remove('active');
    });
  });

  document.querySelector('body').addEventListener('click', function() {
    forEachAll(locationtoggles, function(index) {
      let toggleid = locationtoggles[index].getAttribute('data-location-toggle');
      document.getElementById(toggleid).classList.remove('active');
    });
  });
}

// ------------------------------------------------
// jQuery Dependent
// ------------------------------------------------
jQuery(document).ready(function($) {
  // Masking Plugin
  $('.mask-date').inputmask('99/99/9999');
  $('.mask-ssn').inputmask('999-99-9999');
  $('.mask-taxid').inputmask('99-9999999');
  $('.mask-zip').inputmask('99999');
  $('.mask-expire').inputmask('99/99');
  $('.mask-phone').inputmask('(999) 999-9999');

  // =========-----------------------
  //   Bootstrap Plugins
  // =========-----------------------
  $('#myTabs a').click(function(e) {
    e.preventDefault();
    $(this).tab('show');
  });

  $('#tsTabs a').click(function(e) {
    e.preventDefault();
    $(this).tab('show');
  });

  $('[data-toggle="popover"]').popover({
    html: true
  });

  // $(document).on('click', '[data-target="#deductibleExample"]', function() {
  //   $('[data-toggle="popover"]').popover('hide');
  // });

  // $('body').on('click', function(e) {
  //   $('[data-toggle="popover"]').each(function() {
  //     if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
  //       $(this).popover('hide');
  //     }
  //   });
  // });

  $('[data-toggle="tooltip"]').tooltip({
    html: true
  });

  $('.carousel').carousel({
    interval: 8000
  });
  $('.carousel-control.left').click(function() {
    $('#reminders-slider').carousel('prev');
  });

  $('.carousel-control.right').click(function() {
    $('#reminders-slider').carousel('next');
  });

  $('#familyDoctors').carousel({
    interval: false
  });
  $('.carousel-control.left').click(function() {
    $('#familyDoctors').carousel('prev');
  });

  $('.carousel-control.right').click(function() {
    $('#familyDoctors').carousel('next');
  });

  window.setTimeout(function() {
    if ($('.nav-tabs.responsive').length > 0) {
      fakewaffle.responsiveTabs(['xs']);
    }
  }, 1000);

  // $('.dob-field').on('input', function() {

  //   $(this).on('keydown', function(e) {
  //     var v = this.value;
  //     var key = event.keyCode || event.charCode;

  //     if(key == 8 || key == 46) {
  //     }else {
  //       if (v.match(/^\d{2}$/) !== null) {
  //           this.value = v + '/';
  //       } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
  //           this.value = v + '/';
  //       }
  //     }
  //   });

  // })

  // var input = $('.dob-field');
  // input.on('keydown', function() {
  //   var key = event.keyCode || event.charCode;

  //   if( key == 8 || key == 46 ){
  //     console.log('hello')
  //   }
  // });

  // =========-----------------------
  //   Table Overflow
  // =========-----------------------
  var overflow = function(el) {
    if (el[0].scrollWidth > el.innerWidth()) {
      el.addClass('overflow');
    } else {
      el.removeClass('overflow');
    }
    $(window).resize(function() {
      if (el[0].scrollWidth > el.innerWidth()) {
        el.addClass('overflow');
      } else {
        el.removeClass('overflow');
      }
    });
  };

  if ($('.td-overflow').length >= 1) {
    $('.td-overflow').each(function() {
      overflow($(this));
    });
  }

  // =========-----------------------
  //   Id Card Modal
  // =========-----------------------
  var idCardShow = function(clickEl, contentEl) {
    clickEl.addClass('active');
    contentEl.show();
    contentEl.addClass('active');
  };

  var idCardShowHide = function() {
    var idCardNum = $('.icm__num'),
      idCardInfo = $('.icm__info'),
      idCardWrap = $('.id-card-modal__inner');

    idCardNum.on('click', function() {
      var el = $(this),
        elId = el.attr('data-icm-num'),
        elInfo = idCardWrap.find('div[data-icm-content=' + elId + ']');

      idCardNum.removeClass('active');
      idCardInfo.hide();
      idCardShow(el, elInfo);
    });
  };

  if ($('#id-card-modal').length >= 1) {
    idCardShowHide();
  }

  // =========-----------------------
  //   Sliding Placeholder
  // =========-----------------------
  var fgSlideValid = function(fgInput, fgParent) {
    if (fgInput.val().length >= 1) {
      fgParent.addClass('field-has-val');
    } else {
      fgParent.removeClass('field-has-val');
    }
  };

  if ($('.form-group--slide').length >= 1) {
    $('.form-group--slide .form-control').on('focus', function() {
      $(this)
        .closest('.form-group--slide')
        .addClass('field-focus');
    });

    $('.form-group--slide .form-control').on('blur', function() {
      var el = $(this),
        elParent = el.closest('.form-group--slide');

      elParent.removeClass('field-focus');

      setTimeout(function() {
        fgSlideValid(el, elParent);
      }, 50);
    });

    setTimeout(function() {
      var i = 0;

      $('.form-group--slide .form-control').each(function() {
        var el = $(this),
          elParent = el.closest('.form-group--slide');

        fgSlideValid(el, elParent);

        i++;
      });

      // $('.narrow-search__form__field input[type=text]').each(function() {
      //   var el = $(this),
      //     elParent = el.closest('.form-group--slide');
      //   fgSlideValid(el, elParent);
      // });
    }, 50);
  }

  // if ($('.care-locator').length >= 1) {
  //   $('.narrow-search__form__field--mobile-complex').on('click', function() {
  //     $('.narrow-search__form__field--complex').slideToggle();
  //   });

  //   $('.narrow-search__form__field input[type=text]').on('focus', function() {
  //     $(this)
  //       .parent()
  //       .addClass('field-focus');
  //   });

  //   $('.narrow-search__form__field input[type=text]').on('blur', function() {
  //     var el = $(this),
  //       elParent = el.parent();

  //     elParent.removeClass('field-focus');

  //     fgSlideValid(el, elParent);
  //   });

  //   setTimeout(function() {
  //     $('.narrow-search__form__field input[type=text]').each(function() {
  //       var el = $(this),
  //         elParent = el.parent();
  //       fgSlideValid(el, elParent);
  //     });
  //   }, 50);
  // }

  // =========-----------------------
  //   Sticky Filters
  // =========-----------------------
  if ($('.providers-filters__wrapper').length > 0) {
    var menu = document.querySelector('.providers-filters__wrapper');
    var menuPosition = menu.getBoundingClientRect();
    var placeholder = document.createElement('div');
    placeholder.style.width = menuPosition.width + 'px';
    placeholder.style.height = menuPosition.height + 'px';
    var isAdded = false;

    window.addEventListener('scroll', function() {
      if (window.pageYOffset >= menuPosition.top && !isAdded) {
        menu.classList.add('sticky');
        menu.parentNode.insertBefore(placeholder, menu);
        isAdded = true;
      } else if (window.pageYOffset < menuPosition.top && isAdded) {
        menu.classList.remove('sticky');
        menu.parentNode.removeChild(placeholder);
        isAdded = false;
      }
    });
  }

  // =========-----------------------
  //   Simple Collapse
  // =========-----------------------
  var scCollapse = function(el) {
    el.siblings('.sc-content').slideToggle();
  };
  $('.sc-title').on('click', function(e) {
    e.stopPropagation();
    if ($(window).width() < 768) {
      scCollapse($(this));
    }
  });

  // =========-----------------------
  //   Simple Collapse
  // =========-----------------------
  // var scCollapse = function(el) {
  //   el.siblings('.sc-content').slideToggle();
  // };
  // $('.sc-title').on('click', function(e) {
  //   e.stopPropagation();
  //   if ($(window).width() < 768) {
  //     scCollapse($(this));
  //   }
  // });

  // =========-----------------------
  //   Progress Timeline
  // =========-----------------------
  // var winLog = function(stuff){window.console.log(stuff);};

  var resizePt = function() {
    var pt = $('.progress-timeline'),
      ptActive = pt.find('.active'),
      ptActivePos = ptActive.position().left,
      ptList = pt.find('ol');

    if ($(window).width() < 651) {
      ptList.css('left', -(ptActivePos - ptActive.width() / 2));
    } else {
      ptList.css('left', '');
    }
  };
  if ($('.progress-timeline--complex')) {
  } else if ($('.progress-timeline').length >= 1) {
    resizePt();
  }
  $(window).resize(function() {
    if ($('.progress-timeline--complex')) {
    } else if ($('.progress-timeline').length >= 1) {
      resizePt();
    }
  });

  // =========-----------------------
  //   progess check
  // =========-----------------------
  var progressCheck = function() {
    if ($('.chart-bar').length >= 1) {
      $('.progress-bar').each(function() {
        if (
          $(this)
            .parent()
            .hasClass('progress--fulfill-3')
        ) {
        } else {
          var el = $(this),
            elParent = el.parent('.progress'),
            elCurrent = elParent.find('.progress-current-amount'),
            elCurrentWidth = elCurrent.width(),
            elWidth = el.width(),
            parentWidth = elParent.width();

          if (elWidth === parentWidth) {
            elParent.removeClass('progress--over50');
            elParent.removeClass('progress--under50');

            elParent.addClass('progress--100');
            elCurrent.css('margin-left', '');
          } else if (elWidth >= parentWidth * 0.5) {
            elParent.removeClass('progress--under50');
            elParent.removeClass('progress--100');

            elParent.addClass('progress--over50');
            elCurrent.css('margin-left', -(elCurrentWidth + 10));
          } else {
            elParent.removeClass('progress--over50');
            elParent.removeClass('progress--100');

            elParent.addClass('progress--under50');
            elCurrent.css('margin-left', '');
          }
        }
      });
    }
  };

  progressCheck();

  // var fufillThreeCheck = function() {
  //   if ($('.progress--fulfill-3').length >= 1) {
  //     $('.progress-bar').each(function(){
  //       var el              = $(this),
  //           elParent        = el.parent('.progress'),
  //           // elCurrent       = elParent.find('.progress-current-amount'),
  //           // elCurrentWidth  = elCurrent.width(),
  //           elWidth         = el.width(),
  //           parentWidth     = elParent.width();

  //       if (elWidth === parentWidth) {
  //         elParent.addClass('progress--100');
  //       } else if ( elWidth >=  parentWidth * 0.666) {
  //         elParent.addClass('progress--over66');
  //       }  else if ( elWidth >=  parentWidth * 0.333) {
  //         elParent.addClass('progress--over33');
  //       } else {
  //         elParent.addClass('progress--under33');
  //       }
  //     });
  //   }
  // };
  // fufillThreeCheck();

  // $('.nav-tabs a').on('click', function(){
  //   progressCheck();
  // });

  // $('#collapse-tsTabs').on('shown.bs.collapse', function(){
  //   progressCheck();
  // });

  $('.common-services-mobile').change(function() {
    var winWidth = $(window).width(),
      curValue = $('.common-services-mobile option:selected')
        .text()
        .toLowerCase();

    if (winWidth < 768 && curValue == 'view all') {
      $('.wc-all-services').addClass('active');
    }
  });

  $('#viewAllBtn').on('click', function() {
    $('.wc-all-services').addClass('active');
    $(this)
      .parent('div')
      .hide();
  });

  $('.wc-all__close').on('click', function() {
    $('.wc-all-services').removeClass('active');
  });

  // =========-----------------------
  //   Datepicker
  // =========-----------------------
  if ($('.datepicker1').length >= 1) {
    $('.datepicker1').datetimepicker({
      format: 'MM/DD/YYYY'
    });
  }

  if ($('.phs__wrapper').length > 0) {
    $('.phs__number').on('click', function() {
      var el = $(this),
        elNum = el.parent().attr('data-phs-image');

      $('.phs__highlight').removeClass('active');
      el.parent().addClass('active');
      $('.phs__descrip__item').removeClass('active');
      $('.phs__descrip')
        .find('.phs__descrip__item[data-phs-descrip="' + elNum + '"]')
        .addClass('active');
    });
  }

  if ($('.review-doctor').length >= 1) {
    if ($('body').hasClass('review-completed')) {
      return false;
    } else {
      $('.rd__row__scale__star').on('click', function() {
        $(this)
          .prevAll()
          .andSelf()
          .addClass('icon--star-gold--lg');
        $(this)
          .nextAll()
          .removeClass('icon--star-gold--lg');
      });
    }
  }

  jQuery.fn.extend({
    settingsBar: function(chartSize) {
      var barSettings = {
        scaleOverride: true,
        scaleSteps: 1,
        scaleStartValue: 0,
        scaleStepWidth: chartSize,
        scaleShowLabels: false,
        scaleShowGridLines: false,
        barShowStroke: false,
        tooltipTemplate: '$<%= value %>',
        onAnimationComplete: function() {
          this.showTooltip(this.datasets[0].bars);
        },
        tooltipEvents: [],
        showTooltips: true,
        responsive: true
      };
      return barSettings;
    }
  });
});

// -----------------------------------
// Card Swiper
// -----------------------------------
function Swipe(elem, callback) {
  var self = this;
  this.callback = callback;

  function handleEvent(e) {
    self.touchHandler(e);
  }

  elem.addEventListener('touchstart', handleEvent, false);
  elem.addEventListener('touchmove', handleEvent, false);
  elem.addEventListener('touchend', handleEvent, false);
}

Swipe.prototype.touches = {
  touchstart: {
    x: -1,
    y: -1
  },
  touchmove: {
    x: -1,
    y: -1
  },
  touchend: false,
  direction: 'undetermined'
};

Swipe.prototype.touchHandler = function(event) {
  var touch;
  if (typeof event !== 'undefined') {
    if (typeof event.touches !== 'undefined') {
      touch = event.touches[0];
      switch (event.type) {
        case 'touchstart':
        case 'touchmove':
          this.touches[event.type].x = touch.pageX;
          this.touches[event.type].y = touch.pageY;
          break;
        case 'touchend':
          this.touches[event.type] = true;
          var x = this.touches.touchstart.x - this.touches.touchmove.x,
            y = this.touches.touchstart.y - this.touches.touchmove.y;
          if (x < 0) x /= -1;
          if (y < 0) y /= -1;
          if (x > y) this.touches.direction = this.touches.touchstart.x < this.touches.touchmove.x ? 'right' : 'left';
          else this.touches.direction = this.touches.touchstart.y < this.touches.touchmove.y ? 'down' : 'up';
          this.callback(event, this.touches.direction);
          break;
      }
    }
  }
};

function swipeFlip() {
  return function(event, direction) {
    event.preventDefault();
    switch (direction) {
      case 'left':
        document.querySelector('.card').classList.toggle('js-flip');
        break;
      case 'right':
        document.querySelector('.card').classList.toggle('js-flip');
        break;
    }
  };
}

if (document.querySelector('.id-card__preview')) {
  if (deviceOS()) {
    new Swipe(document.querySelector('.id-card__preview'), swipeFlip());
  } else if (!deviceOS()) {
    document.querySelector('.card').addEventListener('click', function() {
      this.classList.toggle('js-flip');
    });
  }
}

function deviceOS() {
  var useragent = navigator.userAgent;

  if (useragent.match(/Android/i)) {
    return 'android';
  } else if (useragent.match(/webOS/i)) {
    return 'webos';
  } else if (useragent.match(/iPhone/i)) {
    return 'iphone';
  } else if (useragent.match(/iPod/i)) {
    return 'ipod';
  } else if (useragent.match(/iPad/i)) {
    return 'ipad';
  } else if (useragent.match(/Windows Phone/i)) {
    return 'windows phone';
  } else if (useragent.match(/SymbianOS/i)) {
    return 'symbian';
  } else if (useragent.match(/RIM/i) || useragent.match(/BB/i)) {
    return 'blackberry';
  } else {
    return false;
  }
}
